import { createContext, useEffect, useState } from "react";

export const RefreshContext = createContext();

const RefreshProvider = ({ children }) => {
	const [isRefresh, setIsRefresh] = useState(false);

	useEffect(() => {
		if (isRefresh) setIsRefresh(false);
	}, [isRefresh]);

	return <RefreshContext.Provider value={{ isRefresh, setIsRefresh }}>{children}</RefreshContext.Provider>;
};

export default RefreshProvider;
